import createIcon from '../../createIcon';

/**
 * @component @name ReplyAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA3LjVWNC41TDAgMTEuNUw3IDE4LjVWMTUuNUwzIDExLjVMNyA3LjVaTTEzIDguNVY0LjVMNiAxMS41TDEzIDE4LjVWMTQuNEMxOCAxNC40IDIxLjUgMTYgMjQgMTkuNUMyMyAxNC41IDIwIDkuNSAxMyA4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ReplyAll = createIcon('ReplyAll', [
  [
    'path',
    {
      d: 'M7 7.5V4.5L0 11.5L7 18.5V15.5L3 11.5L7 7.5ZM13 8.5V4.5L6 11.5L13 18.5V14.4C18 14.4 21.5 16 24 19.5C23 14.5 20 9.5 13 8.5Z',
      key: '1v5gx0',
    },
  ],
]);

export default ReplyAll;
